/**
 * PURPOSE: Administrar medallas por disciplina y la consolidación del resumen general.
 * RESPONSIBILITIES: Alternar entre el editor deportivo y los vínculos de instituciones por evento.
 * COLLABORATORS: MedalSportEditor.jsx y MedalConsolidationEditor.jsx.
 * ROUTE: src/area/MedalTableArea/MedalTableArea.jsx
 */
import React, { useState } from "react";
import MedalSportEditor from "./MedalSportEditor.jsx";
import MedalConsolidationEditor from "./MedalConsolidationEditor.jsx";

export default function MedalTableArea() {
  const [view, setView] = useState("sport");
  return (
    <section className="grid gap-5">
      <div className="flex flex-wrap gap-2 rounded-2xl border border-gray-100 bg-white p-2 shadow-sm">
        <button type="button" onClick={() => setView("sport")} className={`rounded-xl px-4 py-3 text-sm font-bold transition ${view === "sport" ? "bg-blue-600 text-white" : "text-gray-600 hover:bg-gray-100"}`}>Medallas por disciplina</button>
        <button type="button" onClick={() => setView("consolidation")} className={`rounded-xl px-4 py-3 text-sm font-bold transition ${view === "consolidation" ? "bg-blue-600 text-white" : "text-gray-600 hover:bg-gray-100"}`}>Consolidación general</button>
      </div>
      {view === "sport" ? <MedalSportEditor /> : <MedalConsolidationEditor />}
    </section>
  );
}
